/**
 * The one round the iPhone shell serves. Lives in its own module so the
 * shell's leaves (the presence recorder's page source) can name the round
 * without importing the app component that mounts them.
 */
export const IPHONE_ROUND_ID = "r-8PQ8le63";
